// removed by extract-text-webpack-plugin
module.exports = {"chart":"chart__24_yv"};


//////////////////
// WEBPACK FOOTER
// ./src/containers/Network/coms/GatewayView/coms/GatewayPie/styles.scss
// module id = 2294
// module chunks = 1